import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { SpellViewComponent } from "./components/spell-view/spell-view.component";
import { SpellDetailComponent } from "./components/spell-detail/spell-detail.component";
import { SpellDashboardComponent } from "./containers/spell-dashboard/spell-dashboard.component";

import { PrintAllPipe } from "../shared/pipes/printAll.pipe";

import { SpellsService } from "../shared/services/spells/spells.service";

import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [
    SpellViewComponent,
    SpellDetailComponent,
    SpellDashboardComponent
  ],
  exports: [SpellDashboardComponent],
  imports: [CommonModule, FormsModule, HttpModule, SharedModule.forRoot()],
  providers: []
})
export class SpellDashboardModule {}



// WEBPACK FOOTER //
// ./src/spell-dashboard/spell-dashboard.module.ts